import { Link, useLocation } from "react-router-dom";

/**
 * BottomNav — iOS/Android-style tab bar fixed at the bottom of the viewport.
 * Shows exactly 5 primary entries (one of them typically "Mais" opening the
 * hamburger drawer for secondary items). Only rendered on mobile viewports
 * (the caller uses `lg:hidden`).
 *
 * @param items Array of {key, path, label, icon, onClick?, testId?}
 */
export default function BottomNav({ items }) {
  const loc = useLocation();
  return (
    <nav
      aria-label="Navegação principal"
      className="lg:hidden fixed bottom-0 inset-x-0 z-30 bg-[#041f1b]/95 backdrop-blur border-t border-[#1a4640]"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
      data-testid="bottom-nav"
    >
      <ul className="grid grid-cols-5">
        {items.map(it => {
          const active = it.path && (loc.pathname === it.path || loc.pathname.startsWith(it.path + "/"));
          const common = "flex flex-col items-center justify-center gap-1 py-2.5 text-[10px] uppercase tracking-widest transition-colors";
          const cls = active
            ? "text-[#d4af37]"
            : "text-[#a0b2af] hover:text-[#fdfbf7]";
          const Ic = it.icon;
          const inner = (
            <>
              <span className="relative">
                <Ic size={20} />
                {it.badge > 0 && (
                  <span className="absolute -top-1.5 -right-2 min-w-[16px] h-4 px-1 rounded-full bg-[#d4af37] text-[#041f1b] text-[9px] font-bold flex items-center justify-center"
                        data-testid={`${it.testId}-badge`}>
                    {it.badge > 9 ? "9+" : it.badge}
                  </span>
                )}
              </span>
              <span>{it.label}</span>
              {active && <span className="absolute top-0 left-1/2 -translate-x-1/2 w-10 h-0.5 bg-[#d4af37]" />}
            </>
          );
          if (it.onClick) {
            return (
              <li key={it.key} className="relative">
                <button onClick={it.onClick} className={`${common} ${cls} w-full`}
                        data-testid={it.testId || `bnav-${it.key}`}>
                  {inner}
                </button>
              </li>
            );
          }
          return (
            <li key={it.key} className="relative">
              <Link to={it.path} className={`${common} ${cls}`}
                    data-testid={it.testId || `bnav-${it.key}`}>
                {inner}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
